import { css } from 'linaria';

export const fencesGatesSection = css`
  && {
    .swiper-wrapper {
      @media (--from-desktop) {
        column-gap: 24px;
      }
    }

    .swiper {
      @media (--only-mobile) {
        margin-bottom: 16px;
      }
    }
  }
`;

export const fencesGatesSectionImage = css`
  width: 144px;
  height: 144px;
  margin-bottom: 24px;
`;

export const fencesGatesSectionName = css`
  width: 176px;

  @media (--only-desktop) {
    width: 205px;
  }

  @media (--only-tablet) {
    width: 193px;
  }

  @media (--only-mobile) {
    width: 204px;
  }
`;

export const fencesGatesSectionContent = css`
  width: 776px;

  @media (--only-desktop) {
    width: 616px;
  }

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const fencesGatesSectionContentText = css`
  margin-bottom: 4px;
`;

export const fencesGatesSectionContentList = css`
  margin-bottom: 10px;

  && {
    li:not(:last-child) {
      margin-bottom: 4px;
    }
  }
`;
